<template>
    <div class="adminBar" :class="{ inline: inline }">
        <div v-for="(a, i) in admin" :key="i" @click="setAdmin(a)" :class="{ active: a.state }">
            <div class="setting" v-ripple :class="{ state: a.state }">
                <svg v-if="a.setting === 'vpn' || a.setting === 'tailscale'" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4C11 4.55228 11.4477 5 12 5Z" fill="#fff" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M16 1C16 1 17.5 2 17.5 4C17.5 6 16 7 16 7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M8 1C8 1 6.5 2 6.5 4C6.5 6 8 7 8 7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M7 23L8.11111 19M17 23L15.8889 19M14.5 14L12 5L9.5 14M14.5 14H9.5M14.5 14L15.8889 19M9.5 14L8.11111 19M8.11111 19H15.8889" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> </svg>
                <svg v-if="a.setting === 'bluetooth'" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M6.75 8L17.25 16.5L11.75 22V2L17.25 7.5L6.75 16" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> </svg>
                <svg v-if="a.setting === 'sunshine'" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M2 20.01L2.01 19.9989" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M15 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4C2.89543 4 2 4.89543 2 6V7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M2 16C4 16.5 5.5 18 6 20" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M2 12C6 12.5 9.5 16 10 20" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> </svg>
                <svg v-if="a.setting === 'hyperion'" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M21 2L20 3" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M3 2L4 3" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M21 16L20 15" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M3 16L4 15" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M9 18H15" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M10 21H14" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M11.9998 3C7.9997 3 5.95186 4.95029 5.99985 8C6.02324 9.48689 6.4997 10.5 7.49985 11.5C8.5 12.5 9 13 8.99985 15H14.9998C15 13.0001 15.5 12.5 16.4997 11.5001L16.4998 11.5C17.4997 10.5 17.9765 9.48689 17.9998 8C18.0478 4.95029 16 3 11.9998 3Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> </svg>
                <span> {{ a.displayName || a.setting }} </span>
                <div :class="{ state: a.state }" class="toggle">
                    <div class="ball"> </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
  name: 'didadmin',
  props: { did: String, inline: Boolean },

  computed: { },

  data: function(){
    return {
        admin: [],
        version: null,
        id: Math.random().toString(36).slice(2),
    }
  },

watch: {
    did: function(did){
        if(did){
            this.getAdmin()
        }else{
            this.admin = []
        }
    }
},

  methods: {
         updateAdmin(admin) {
            this.admin = admin.sort((a, b) => {
                const nameA = a.setting.toLowerCase();
                const nameB = b.setting.toLowerCase();

                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;

            })
        },

        getAdmin() {
            window.afetch('/admin?did=' + window.did).then(response => response.json()).then((data) => {
                this.updateAdmin(data.admin)
                this.version = data.version
                this.$emit('version', data.version)
            })
        },
        async setAdmin(admin) {
            const request = await window.afetch(`/setAdmin?did=${window.did}`, { method: 'POST', body: JSON.stringify(admin) })
            let data = await request.json()
            this.updateAdmin(data.admin)
            this.$root.$emit('adminUpdate', this.id)
        },

  },

  beforeDestroy: function(){
    this.$root.$off('adminUpdate')
  },

  mounted: function(){
    this.getAdmin()
    this.$root.$on('adminUpdate', (id) => {
        if(id === this.id) return
        this.getAdmin()
    })
  }
}
</script>

<style scoped lang="scss">
.adminBar {
    display: flex;
    position: relative;
    flex-direction: column;
    top: 0;
    right: 0;
    margin: 0px;
    &.inline{
        flex-direction: row;

        .setting{
            border: 1px solid white;
            border-radius: 5px;
            margin: 0 7.5px;

            svg{
                margin: 0 auto;
                padding: 5px 10px!important;
            }
            &.state{
                background-color: white;

                svg{
                    color: black;
                    path{
                        stroke: black!important;
                    }
                }
            }
        }
        .toggle{
            display: none;
        }
        span{
            display: none;
        }
    }



    >div {
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .setting {
            flex-grow: 1;
            display: flex;
            align-items: center;
            margin: 5px 0;
            padding: 5px 0;
            text-transform: uppercase;
            letter-spacing: 2px;
            font-size: 9px;

            span {
                flex-grow: 1;
            }

            svg {
                padding-right: 5px !important;
                margin-right: 20px;
                padding: 5px;

            }

            .toggle {
                width: 50px;
                height: 25px;
                border: 1px solid white;
                position: relative;
                border-radius: 20px;
                ;
                opacity: 0.5;

                .ball {
                    width: 20px;
                    height: 20px;
                    position: absolute;
                    top: 2.5px;
                    margin: 0 2.5px;
                    left: 0;
                    border-radius: 50%;
                    background-color: white;
                }

                &.state {
                    opacity: 1;

                    .ball {
                        transform: translateX(24px)
                    }

                }
            }

        }
    }
}

</style>
